

// import '@mdi/font/css/materialdesignicons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';
import {
  mdiAccount,
  mdiChevronLeftBoxOutline,
  mdiChevronLeft,
  mdiChevronRight,
  mdiCircleMedium,
  mdiCircleSmall,
  mdiClose,
  mdiMagnify,
  mdiChevronDown,
  mdiChevronUp,
  mdiCheck,
  mdiArrowRight,
  mdiPhoneInTalkOutline,
  mdiMinus,
  mdiArrowLeft,
  mdiLogin,
  mdiSchoolOutline,
  mdiFaceAgent,
  mdiCartOutline,
  mdiHelp,
  mdiPlus,
  mdiCart,
  mdiCheckboxOutline,
  mdiArrowRightCircle, mdiArrowLeftCircle, mdiClockOutline,
  mdiMenuDown,
  mdiAccountPlus,
  mdiNearMe,
  mdiFilter,
  mdiStarOutline,
  mdiStarHalfFull,
  mdiStar,
  mdiCalendarClock,
  mdiPhone,
  mdiWeb,
} from '@mdi/js'

// import { aliases, fa } from 'vuetify/iconsets/fa'

/** @description config icon sets  for vuetify */

/**  to set icons
 *   @constant
 *   @type {string}
 *   @default mdi
 *  **/
const defaultIconSet = "mdi";
export default {
  defaultSet: defaultIconSet, // This is already the default value - only for display purposes,
  aliases: {
    ...aliases,
    account: mdiAccount,
    magnify: mdiMagnify,
    close: mdiClose,
    mdiArrowRight: mdiArrowRight,
    mdiArrowLeft: mdiArrowLeft,
    mdiChevronLeft: mdiChevronLeft,
    mdiChevronLeftBoxOutline:mdiChevronLeftBoxOutline,
    chevronLeft: mdiChevronLeft,
    chevronRight: mdiChevronRight,
    circleSmall: mdiCircleSmall,
    circleMedium: mdiCircleMedium,
    mdiChevronDown: mdiChevronDown,
    mdiChevronUp: mdiChevronUp,
    mdiCheck: mdiCheck,
    mdiMinus: mdiMinus,
    mdiLogin: mdiLogin,
    mdiSchoolOutline: mdiSchoolOutline,
    mdiFaceAgent:mdiFaceAgent,
    mdiMenuDown: mdiMenuDown,
    mdiCartOutline:mdiCartOutline,
    mdiCart: mdiCart,
    mdiHelp: mdiHelp,
    mdiPlus: mdiPlus,
    mdiCheckboxOutline:mdiCheckboxOutline,
    mdiArrowRightCircle:mdiArrowRightCircle,
    mdiArrowLeftCircle:mdiArrowLeftCircle,
    mdiClockOutline: mdiClockOutline,
    mdiPhoneInTalkOutline: mdiPhoneInTalkOutline,
    mdiAccountPlus: mdiAccountPlus,
    mdiNearMe: mdiNearMe,
    mdiFilter: mdiFilter,
    mdiStarOutline: mdiStarOutline,
    mdiStarHalfFull: mdiStarHalfFull,
    mdiStar: mdiStar,
    mdiCalendarClock: mdiCalendarClock,
    mdiPhone,
    mdiWeb,
  },

  // aliases,
  sets: {
    mdi, //material icon sets
    // fa, //font awesome
  },
}
